import Urls from '../config/Urls';

export default function getLoginUrl(returnUrl: string) {

  return `${Urls.Login}/login?returnUrl=${encodeURI(returnUrl)}`
}
